export default __webpack_public_path__ + "static/media/Dune-hd-2.d327e485.jpg";